const NEST_RETOMADA_BODY =
  'Olá, {{1}}! Tudo bem?\n\nVocê demonstrou interesse em conhecer o NEST Mountain Lodge, em Gramado. Ainda gostaria de receber mais informações?';
const NEST_RETOMADA_FOOTER =
  'Se preferir não receber mensagens, responda SAIR.';
const OPERATOR_PRESENTATION_BODY = 'Oi, tudo bem? Aqui é {{1}}, da Ownerinc!';

const nestRetomadaManual = Object.freeze({
  bodyVariable: '1',
  category: 'MARKETING',
  language: 'pt_BR',
  semantics: 'FIRST_NAME',
  bodyText: NEST_RETOMADA_BODY,
  footerText: NEST_RETOMADA_FOOTER,
});

export const MANUAL_FIRST_NAME_TEMPLATE_ALLOWLIST = Object.freeze({
  nest_retomada_manual_v1: nestRetomadaManual,
});

const operatorPresentationManual = Object.freeze({
  bodyVariable: '1',
  category: 'MARKETING',
  language: 'pt_BR',
  semantics: 'OPERATOR_FIRST_NAME',
  bodyText: OPERATOR_PRESENTATION_BODY,
  footerText: null,
});

export const MANUAL_OPERATOR_FIRST_NAME_TEMPLATE_ALLOWLIST = Object.freeze({
  ownerinc_apresentacao_operador_v1: operatorPresentationManual,
});

const technicalAliases = new Set([
  'admin',
  'cliente',
  'contato',
  'desconhecido',
  'lead',
  'nest',
  'ownerinc',
  'prospect',
  'semnome',
  'test',
  'teste',
  'unknown',
  'user',
  'usuario',
  'whatsapp',
]);

const ineligiblePrefill = Object.freeze({
  eligible: false,
  value: '',
  bodyVariable: null,
});

const ineligibleOperatorPrefill = Object.freeze({
  ...ineligiblePrefill,
  semantics: null,
});

const normalizeAlias = value =>
  value.normalize('NFD').replace(/\p{M}/gu, '').toLocaleLowerCase('pt-BR');

const firstHumanToken = contactName => {
  const normalizedName = contactName.trim().replace(/\s+/gu, ' ');
  if (!normalizedName || normalizedName.includes('@')) return '';

  const [token] = normalizedName.split(' ');
  const isHumanToken = /^\p{L}[\p{L}\p{M}'’-]*\p{L}$/u.test(token);
  if (!isHumanToken || technicalAliases.has(normalizeAlias(token))) return '';

  return token;
};

const hasProvenTemplateShape = (template, manifest) => {
  const components = Array.isArray(template.components)
    ? template.components
    : [];
  const bodyComponents = components.filter(({ type }) => type === 'BODY');
  const footerComponents = components.filter(({ type }) => type === 'FOOTER');
  const hasUnsupportedComponent = components.some(
    ({ type }) => !['BODY', 'FOOTER'].includes(type)
  );

  return (
    template.language === manifest.language &&
    template.category === manifest.category &&
    !hasUnsupportedComponent &&
    bodyComponents.length === 1 &&
    bodyComponents[0].text === manifest.bodyText &&
    (manifest.footerText === null
      ? footerComponents.length === 0
      : footerComponents.length === 1 &&
        footerComponents[0].text === manifest.footerText)
  );
};

export const getManualTemplateFirstNamePrefill = (template, contactName) => {
  const manifest = MANUAL_FIRST_NAME_TEMPLATE_ALLOWLIST[template?.name];
  if (!manifest || !hasProvenTemplateShape(template, manifest)) {
    return ineligiblePrefill;
  }

  return {
    eligible: true,
    value: typeof contactName === 'string' ? firstHumanToken(contactName) : '',
    bodyVariable: manifest.bodyVariable,
  };
};

export const getManualTemplateOperatorFirstNamePrefill = (
  template,
  operatorName
) => {
  const manifest =
    MANUAL_OPERATOR_FIRST_NAME_TEMPLATE_ALLOWLIST[template?.name];
  if (!manifest || !hasProvenTemplateShape(template, manifest)) {
    return ineligibleOperatorPrefill;
  }

  return {
    eligible: true,
    value:
      typeof operatorName === 'string' ? firstHumanToken(operatorName) : '',
    bodyVariable: manifest.bodyVariable,
    semantics: manifest.semantics,
  };
};
